import React from 'react';
import { Button, FlatList } from 'native-base';
import { Caption } from '~/shared/Typography';
import { ProductListProps } from '~/pages/shop/components/ProductList';
import { ProductListPageProps, useDutchieStore } from '@springbig/shared';
import { useShopStyles } from '~/shared/styles';
import { useAppNavigate } from '~/pages';

export const CategoriesList = () => {

    const { setProductListProps, menuCategories, isBusy } = useDutchieStore();
    const {
        button_background,
        button_text,
    } = useShopStyles();
    const { navigate, params } = useAppNavigate();

    return (
        <FlatList
            horizontal={true}
            px={2}
            pb={3}
            data={menuCategories.filter(category => category.displayCategory)}
            renderItem={({ item, index } : { item: ProductListProps, index: number }) =>

                <Button
                    bg={button_background}
                    rounded={'md'}
                    mx={index % 2 === 0 ? 0 : 2}
                    px={1}
                    py={0}
                    alignItems={'center'}
                    opacity={isBusy ? .7 : 1}
                    isDisabled={isBusy}
                    _hover={{ bg: button_background }}
                    onPress={() => {

                        const productListProps: ProductListPageProps = {
                            title: item.title,
                            category: item.category,
                            subCategory: item.subcategory,
                            menuSection: item.menuSection,
                        };
                        setProductListProps(productListProps);
                        navigate(`w/${params.wallet_id}/shop/product_list`);
                    }}
                >
                    <Caption color={button_text}>
                        { item.title }
                    </Caption>
                </Button>
            }
        />
    );
};
